export default "__VITE_ASSET__eHhFsaqu__"